export default __webpack_public_path__ + "static/media/cadastro_banner.aae71c0c.png";